import { render } from "./CustomerHomeView.vue?vue&type=template&id=7cc0130b&scoped=true&ts=true&lang=pug"
import script from "./CustomerHomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerHomeView.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerHomeView.vue?vue&type=style&index=0&id=7cc0130b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc0130b"]])

export default __exports__